import { render, staticRenderFns } from "./Strike.vue?vue&type=template&id=13d2c3ea&"
import script from "./Strike.vue?vue&type=script&lang=js&"
export * from "./Strike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports